import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, CalendarDays } from "lucide-react";
import { fetchBlogPosts } from "../lib/api";
import Seo from "../components/Seo";

const fmtDate = (iso) => {
  try { return new Date(iso).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" }); }
  catch { return ""; }
};

const Blog = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    fetchBlogPosts().then(setPosts).catch(() => setPosts([])).finally(() => setLoading(false));
  }, []);

  return (
    <div className="max-w-7xl mx-auto px-4 md:px-8 py-12">
      <Seo
        path="/blog"
        title="Cake Ideas, Recipes & Guides | Noida & Greater Noida"
        description="Tips, ideas and guides on ordering the best cakes in Noida & Greater Noida — eggless flavours, birthday cake picks, custom & photo cakes and fresh delivery from Globaltreats."
      />
      <div className="text-center mb-12">
        <h1 className="font-display text-4xl md:text-5xl font-bold text-[#3A2417]">The Globaltreats Journal</h1>
        <p className="text-[#B07A5C] mt-3 max-w-xl mx-auto">Cake ideas, flavour guides and everything sweet — from our kitchen in Noida to your celebration.</p>
      </div>

      {loading ? (
        <p className="text-center text-[#B07A5C] py-16">Loading articles...</p>
      ) : posts.length === 0 ? (
        <p className="text-center text-[#B07A5C] py-16">No articles yet. Check back soon!</p>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8" data-testid="blog-grid">
          {posts.map((p) => (
            <Link
              key={p.id}
              to={`/blog/${p.slug}`}
              className="group bg-white rounded-3xl overflow-hidden bakery-shadow hover:bakery-shadow-lg transition-all duration-300 hover:-translate-y-1"
              data-testid={`blog-card-${p.slug}`}
            >
              <div className="aspect-[16/10] overflow-hidden bg-[#F6E7DA]">
                {p.cover_image && <img src={p.cover_image} alt={p.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />}
              </div>
              <div className="p-6">
                <div className="flex items-center gap-1.5 text-xs text-[#B07A5C] mb-2"><CalendarDays size={13} /> {fmtDate(p.created_at)}</div>
                <h2 className="font-display text-xl font-semibold text-[#3A2417] leading-snug line-clamp-2 group-hover:text-[#D46A8A] transition-colors">{p.title}</h2>
                <p className="text-sm text-[#6B4226] mt-2 line-clamp-3">{p.excerpt}</p>
                <span className="inline-flex items-center gap-1.5 text-sm text-[#D46A8A] font-medium mt-4">Read more <ArrowRight size={15} className="group-hover:translate-x-1 transition-transform" /></span>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
};

export default Blog;
